'use client';

import React from 'react';

import { TrilogyProvider as Provider, ToasterAlertProvider } from '@bytel/trilogy-react';

export function TrilogyProvider({ children }: Readonly<{ children: React.ReactNode }>) {
    return (
        <Provider withStyles={false}>
            <ToasterAlertProvider>{children}</ToasterAlertProvider>
        </Provider>
    );
}
